import React, { useEffect, useState } from "react";
import {
  AppBar,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  IconButton,
  Paper,
  Toolbar,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import HeaderRendicion from "./HeaderRendicion";
import TablaComprobantes from "./TablaComprobantes";
import { getData } from "../../../../services/library";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import DownloadIcon from "@mui/icons-material/Download";
import ResumenGarrafas from "./ResumenGarrafas";
import TablaPendientes from "./TablaPendientes";
import moment from "moment";
import TablaEntregasRemitos from "./TablaEntregasRemitos";
import TablaCambios from "./TablaCambios";
import VerificaCorrelatividad from "./VerificaCorrelatividad";
import TablaDescartados from "./TablaDescartados";
import TablaSoloEnvases from "./TablaSoloEnvases";

function ResumenRendicion({ row, onBack }) {
  const [facturas, setFacturas] = useState([]);
  const [pagos, setPagos] = useState([]);
  const [resumenGarrafas, setResumenGarrafas] = useState([]);
  const [entregasConRemito, setEntregasConRemito] = useState([])
  const [cambios, setCambios] = useState([])
  const [loading, setLoading] = useState(true); // Estado de carga
  const [pendientes, setPendientes] = useState([])
  const [faltantes, setFaltantes] = useState([]);
  const [datosFaltantes, setDatosFaltantes] = useState([]);
  const [descartados, setDescartados] = useState([])
  const [soloEnvases, setSoloEnvases] = useState([])
// console.log("FACATURAS",facturas);

  const obtenerFacturas = () => {
    return new Promise((resolve) => {
      getData("/envasado_pedidos/comprobantesrendicion/" + row.uuid, (data) => {
        setFacturas(data);
        resolve();
      });
    });
  };
  
  const obtenerPendientes = () => {
    return new Promise((resolve) => {
      getData("/envasado_pedidos/pendientesrendicion/" + row.uuid, (data) => {
        setPendientes(data);
        resolve();
      });
    });
  };
  

  const obtenerPagos = () => {
    return new Promise((resolve) => {
      getData("/envasado_rendiciones/resumenpagos/" + row.uuid, (data) => {
        setPagos(data);
        resolve();
      });
    });
  };

  const obtenerResumenGarrafas = () => {
    return new Promise((resolve) => {
      getData("/envasado_pedidos_renglon/resumengarrafas/" + row.uuid, (data) => {
        setResumenGarrafas(data);
        resolve();
      });
    });
  };

    const obtenerEntregasRemito = () => {
    return new Promise((resolve) => {
      getData("/envasado_pedidos/xrendicionentregaremito/" + row.uuid, (data) => {
        setEntregasConRemito(data);
        resolve();
      });
    });
  };
  
  const obtenerCambios = () => {
    return new Promise((resolve) => {
      getData("/envasado_pedidos/xrendicioncambios/" + row.uuid, (data) => {
        setCambios(data);
        resolve();
      });
    });
  };
  
  const obtenerDescartados = () => {
    return new Promise((resolve) => {
      getData("/envasado_pedidos/rendicion-standby/" + row.uuid, (data) => {
        setDescartados(data);
        resolve();
      });
    });
  };

  // Pedidos sólo con envases (estado 366): no tienen factura
  const obtenerSoloEnvases = () => {
    return new Promise((resolve) => {
      getData("/envasado_pedidos/xrendicionsoloenvases/" + row.uuid, (data) => {
        setSoloEnvases(data);
        resolve();
      });
    });
  };

// Función para verificar correlatividad agrupando por letra
const verificarCorrelatividad = async (facturas) => {
  // Agrupar facturas por letra
  const facturasPorLetra = {};
  
  facturas.forEach(f => {
    if (f.texto_comprobante === "FACTURA") {
      const letra = f.letra || 'SIN_LETRA';
      if (!facturasPorLetra[letra]) {
        facturasPorLetra[letra] = [];
      }
      facturasPorLetra[letra].push(f);
    }
  });

  const letras = Object.keys(facturasPorLetra);
  
  if (letras.length === 0) {
    console.log("No hay facturas para verificar correlatividad");
    setFaltantes([]);
    setDatosFaltantes([]);
    return;
  }

  // Arrays para acumular todos los faltantes y datos
  let todosFaltantes = [];
  let todosDatosFaltantes = [];

  // Procesar cada grupo por separado
  for (const letra of letras) {
    const facturasGrupo = facturasPorLetra[letra];
    
    // Separar anuladas y válidas
    const facturasValidas = facturasGrupo.filter(f => f.estado_factura !== 260);
    const facturasAnuladas = facturasGrupo.filter(f => f.estado_factura === 260);
    const facturasEmitidas = facturasGrupo;

    // Ordenar por número
    const todasOrdenadas = [...facturasEmitidas].sort((a, b) => a.nro_comprobante - b.nro_comprobante);
    
    const primerNumero = todasOrdenadas[0].nro_comprobante;
    const ultimoNumero = todasOrdenadas[todasOrdenadas.length - 1].nro_comprobante;
    const cantidadEsperada = ultimoNumero - primerNumero + 1;
    const cantidadReal = todasOrdenadas.length;

    const numerosExistentes = new Set(todasOrdenadas.map(f => f.nro_comprobante));
    
    // Encontrar faltantes
    const faltantes = [];
    for (let i = primerNumero; i <= ultimoNumero; i++) {
      if (!numerosExistentes.has(i)) {
        faltantes.push(i);
      }
    }

    // Encontrar duplicados
    const duplicados = [];
    const conteo = {};
    facturasEmitidas.forEach(f => {
      conteo[f.nro_comprobante] = (conteo[f.nro_comprobante] || 0) + 1;
    });
    Object.keys(conteo).forEach(key => {
      if (conteo[key] > 1) {
        duplicados.push({ numero: parseInt(key), cantidad: conteo[key] });
      }
    });

    if (faltantes.length > 0) {
      
      // Acumular números faltantes
      todosFaltantes = [...todosFaltantes, ...faltantes];
      
      // Consultar correlatividad para los números faltantes
      if (facturas.length > 0) {
        const ptoVenta = facturas[0].pto_venta;
        
        try {
          const datosCorrelatividad = await obtenerCorrelatividad(ptoVenta, faltantes);
          
          if (datosCorrelatividad && datosCorrelatividad.length > 0) {
            // Filtrar por letra
            const datosFiltrados = datosCorrelatividad.filter(row => row.letra === letra);
            
            if (datosFiltrados.length > 0) {
              
              // Acumular datos encontrados
              todosDatosFaltantes = [...todosDatosFaltantes, ...datosFiltrados];
            } else {
              console.log(`  No se encontraron datos para los números faltantes con letra ${letra}`);
            }
          } else {
            console.log(`    No se encontraron datos para los números faltantes en la base de datos.`);
          }
        } catch (error) {
          console.error(`   Error al consultar correlatividad:`, error);
        }
      }
    } else {
      console.log(`   No hay números faltantes en el rango`);
    }

    console.log(''); // Línea en blanco entre grupos
  }

  // Actualizar estados con todos los faltantes y datos encontrados
  setFaltantes(todosFaltantes);
  setDatosFaltantes(todosDatosFaltantes);
};

// Función para obtener datos de correlatividad
const obtenerCorrelatividad = (ptoVenta, numerosFaltantes) => {
  return new Promise((resolve, reject) => {
    const comprobantesStr = numerosFaltantes.join(',');
    getData(`/envasado_pedidos/correlatividad/${ptoVenta}/${comprobantesStr}`, (data) => {
      resolve(data);
    }, (error) => {
      reject(error);
    });
  });
};

// Actualizar los useEffect
useEffect(() => {
  const cargarDatos = async () => {
    setLoading(true);
    // Fuera del Promise.all: getData no resuelve si la API falla, y esto no
    // debe bloquear la carga del resto del resumen.
    obtenerSoloEnvases();
    try {
      await Promise.all([
        obtenerFacturas(),
        obtenerPendientes(),
        obtenerPagos(),
        obtenerResumenGarrafas(),
        obtenerEntregasRemito(),
        obtenerCambios(),
        obtenerDescartados()
      ]);
    } catch (error) {
      console.error("Error al cargar los datos:", error);
    } finally {
      setLoading(false);
    }
  };

  cargarDatos();
}, []);

useEffect(() => {
  if (facturas.length > 0) {
    verificarCorrelatividad(facturas);
  }
}, [facturas]);

const downloadPDF = () => {
  const doc = new jsPDF("p", "pt", "a4");

  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;
  const margin = { top: 40, bottom: 45, left: 28, right: 28 };
  const usableWidth = pageWidth - margin.left - margin.right;

  /* ── helpers ── */
  const safeNumber = (v) => {
    const n = Number(v);
    return isNaN(n) ? 0 : n;
  };

  const formatCurrency = (value) =>
    "$ " +
    safeNumber(value).toLocaleString("es-AR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const getAclaracionPromoSena = (str) => {
    if (!str || str === "") return null;
    return str;
  };

  /* ── parsers ── */
  const parseProductos = (productoFactItem) => {
    if (!productoFactItem || typeof productoFactItem !== "string") return [];
    const renglones = productoFactItem.split(" -- ");
    return renglones.map((renglon) => {
      const patterns = {
        cantidad:     /(\d+\.?\d*)\s*x\s+/,
        articulo:     /\d+\.?\d*\s*x\s+(.+?)\s+\(Unit\./,
        precioSinIva: /Unit\. sin IVA \$(\d+\.?\d*)/,
        precioConIva: /Unit\. con IVA \$(\d+\.?\d*)/,
        totalSinIva:  /total sin IVA \$(\d+\.?\d*)/i,
        total:        /Total \$(\d+\.?\d*)/,
      };
      const cantidad = parseFloat(renglon.match(patterns.cantidad)?.[1] || 0);
      let articulo = renglon.match(patterns.articulo)?.[1]?.trim() || "";
      articulo = articulo.replace(/\[PROMO\]/g, "").replace(/\[SEÑA\]/g, "").trim();
      const precioUnitario = parseFloat(renglon.match(patterns.precioSinIva)?.[1] || 0);
      const precioUnitarioConIva = parseFloat(renglon.match(patterns.precioConIva)?.[1] || 0);
      const totalSinIva = renglon.match(patterns.totalSinIva)?.[1];
      const neto = totalSinIva ? parseFloat(totalSinIva) : precioUnitario * cantidad;
      const total = parseFloat(renglon.match(patterns.total)?.[1] || 0);
      const iva = total - neto;
      return { cantidad, articulo, precioUnitario,precioUnitarioConIva, neto, iva, importeConIva: total };
    });
  };

  const parseMedioPago = (str) => {
    if (!str) return [];
    return [...str.matchAll(/\[([^\]]+)\]/g)].map((m) => {
      const raw = m[1];
      const nombre = raw.split(" (")[0].trim();
      const montoMatch = raw.match(/\$\s*([0-9.,]+)/);
      const monto = montoMatch ? Number(montoMatch[1].replace(",", ".")) : 0;
      const esEnvase = /envase/i.test(raw);
      const detMatch = raw.match(/\$\s*[0-9.,]+\s*--\s*(.*)\)/);
      return { nombre, monto, esEnvase, detalle: detMatch ? detMatch[1] : null };
    });
  };

  // Formato que arma la query: "id|cantidad|abreviatura|valor_envase -- ..."
  const parseEnvases = (str) => {
    if (!str) return [];
    return str.split(" -- ").map((item) => {
      const [, cantidad, articulo, valor] = item.split("|");
      const cant = Number(cantidad) || 0;
      const valorEnvase = Number(valor) || 0;
      return { cantidad: cant, articulo, valorEnvase, total: cant * valorEnvase };
    });
  };

  const formatFecha = (f) => (f ? new Date(f).toLocaleDateString() : "-");

  /* ══════════════════════════════════════
     ENCABEZADO GLOBAL
  ══════════════════════════════════════ */
  let currentY = margin.top;

  /* ── helpers de layout ── */
  const ensureSpace = (needed) => {
    if (currentY + needed > pageHeight - margin.bottom) {
      doc.addPage();
      currentY = margin.top;
    }
  };

  const sectionTitle = (titulo) => {
    ensureSpace(60);
    doc.setFontSize(10);
    doc.setFont(undefined, "bold");
    doc.setTextColor(0, 0, 0);
    doc.text(titulo.toUpperCase(), margin.left, currentY);
    currentY += 6;
  };

  // Tabla con el mismo estilo que la de productos de los comprobantes
  const simpleTable = (head, body, { columnStyles = {}, boldLastRow = false, left = margin.left, gap = 18 } = {}) => {
    autoTable(doc, {
      startY: currentY,
      head: [head],
      body,
      theme: "plain",
      styles: {
        fontSize: 7.5,
        cellPadding: { top: 3, bottom: 3, left: 4, right: 4 },
        overflow: "linebreak",
        valign: "middle",
        textColor: [0, 0, 0],
      },
      headStyles: {
        fontStyle: "bold",
        fillColor: [235, 235, 235],
        textColor: [0, 0, 0],
        lineWidth: { bottom: 0.5 },
      },
      bodyStyles: {
        fillColor: false,
        lineColor: [220, 220, 220],
        lineWidth: { bottom: 0.2 },
      },
      alternateRowStyles: {
        fillColor: [250, 250, 250],
      },
      columnStyles,
      didParseCell: (data) => {
        if (boldLastRow && data.section === "body" && data.row.index === body.length - 1) {
          data.cell.styles.fontStyle = "bold";
        }
      },
      margin: { left, right: margin.right },
    });
    currentY = doc.lastAutoTable.finalY + gap;
  };

  /* ══════════════════════════════════════
     PIE DE PÁGINA
  ══════════════════════════════════════ */
  const _finalizePDF = () => {
    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setDrawColor(180, 180, 180);
      doc.setLineWidth(0.4);
      doc.line(margin.left, pageHeight - 22, pageWidth - margin.right, pageHeight - 22);
      doc.setFontSize(7);
      doc.setFont(undefined, "normal");
      doc.setTextColor(130, 130, 130);
      doc.text(`Página ${i} de ${totalPages}`, margin.left, pageHeight - 12);
      doc.text(
        new Date().toLocaleString("es-AR"),
        pageWidth - margin.right,
        pageHeight - 12,
        { align: "right" }
      );
    }
    const fileName = `Rendicion_${row.nro_rendicion || "SIN_NUMERO"}_${(row.fecha || "").replace(/\//g, "-")}.pdf`;
    doc.save(fileName);
  };

  doc.setFontSize(13);
  doc.setFont(undefined, "bold");
  doc.setTextColor(0, 0, 0);
  doc.text("Informe detallado de Comprobantes", pageWidth / 2, currentY, { align: "center" });
  currentY += 16;

  const fechaDisplay = row.fecha
    ? moment(row.fecha, ["DD/MM/YYYY", "YYYY-MM-DD"]).format("dddd D [de] MMMM [de] YYYY")
    : "";
  const ptoVentaDisplay = row.pto_venta || "";
  doc.setFontSize(9);
  doc.setFont(undefined, "normal");
  doc.setTextColor(100, 100, 100);
  doc.text(
    `${fechaDisplay} — Punto de venta ${ptoVentaDisplay}`,
    pageWidth / 2,
    currentY,
    { align: "center" }
  );
  currentY += 10;

  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.8);
  doc.line(margin.left, currentY, pageWidth - margin.right, currentY);
  currentY += 14;

  /* ══════════════════════════════════════
     DATOS DE LA PLANILLA (igual que HeaderRendicion)
  ══════════════════════════════════════ */
  const kmInicial = Number(row.km_inicial);
  const kmFinal = Number(row.km_final);
  const diferenciaKm =
    row.km_inicial != null && row.km_final != null && !isNaN(kmInicial) && !isNaN(kmFinal)
      ? kmFinal - kmInicial
      : "-";

  doc.setFontSize(10);
  doc.setFont(undefined, "bold");
  doc.setTextColor(0, 0, 0);
  doc.text(`Planilla N° ${row.nro_rendicion ?? ""}`, margin.left, currentY);
  currentY += 12;

  doc.setFontSize(8.5);
  doc.setFont(undefined, "normal");
  doc.text(`Chofer: ${row.nombre_apellido || "-"} — Vehículo: ${row.patente || "-"}`, margin.left, currentY);
  currentY += 11;
  doc.text(
    `Fecha: ${row.fecha || "-"} — Km Inicial: ${row.km_inicial ?? "-"} — Km Final: ${row.km_final ?? "-"} — Diferencia: ${diferenciaKm}`,
    margin.left,
    currentY
  );
  currentY += 11;
  doc.text(`Sucursal: ${row.nombre_suc || "-"}`, margin.left, currentY);
  currentY += 8;

  doc.setDrawColor(180, 180, 180);
  doc.setLineWidth(0.5);
  doc.line(margin.left, currentY, pageWidth - margin.right, currentY);
  currentY += 18;

  /* ══════════════════════════════════════
     CAMBIOS
  ══════════════════════════════════════ */
  if (Array.isArray(cambios) && cambios.length > 0) {
    sectionTitle("Cambios");
    simpleTable(
      ["ID Pedido", "Razón Social", "CUIT", "Dirección", "Producto", "Fecha", "N° Pegatina"],
      cambios.map((p) => [
        `#${p.id}`,
        p.razon_social || "-",
        p.cuit || "-",
        p.direccion_entrega || "-",
        p.producto_renglon || "-",
        formatFecha(p.fecha_para),
        p.nro_pegatina_cambio || "",
      ])
    );
  }

  /* ══════════════════════════════════════
     PENDIENTES DE FACTURACIÓN
  ══════════════════════════════════════ */
  if (Array.isArray(pendientes) && pendientes.length > 0) {
    sectionTitle("Pendientes de Facturación");
    simpleTable(
      ["ID Pedido", "Razón Social", "CUIT", "Dirección", "Producto", "Fecha"],
      pendientes.map((p) => [
        `#${p.id}`,
        p.razon_social || "-",
        p.cuit || "-",
        p.direccion_entrega || "-",
        p.producto_renglon || "-",
        formatFecha(p.fecha_para),
      ])
    );
  }

  /* ══════════════════════════════════════
     DESCARTADOS
  ══════════════════════════════════════ */
  if (Array.isArray(descartados) && descartados.length > 0) {
    sectionTitle("Descartados");
    simpleTable(
      ["ID Pedido", "Razón Social", "Dirección", "Producto", "Fecha", "Pagos"],
      descartados.map((p) => [
        `#${p.id}`,
        p.cliente || "-",
        p.direccion_entrega || "-",
        p.producto || "-",
        p.fecha_format || "-",
        p.pagos || "",
      ])
    );
  }

  /* ══════════════════════════════════════
     DETALLE DE COMPROBANTES
  ══════════════════════════════════════ */
  sectionTitle("Detalle de Comprobantes");
  currentY += 10;

  if (!facturas.length) {
    doc.setFontSize(9);
    doc.setFont(undefined, "normal");
    doc.setTextColor(100, 100, 100);
    doc.text("No hay comprobantes en esta rendición.", margin.left, currentY);
    doc.setTextColor(0, 0, 0);
    currentY += 20;
  }

  /* ══════════════════════════════════════
     CALCULAR TOTALES GENERALES
  ══════════════════════════════════════ */
  let totalVenta = 0;
  let totalCuentaCorriente = 0;
  let totalContado = 0;

  facturas.forEach((c) => {
    if (c.texto_comprobante === "FACTURA" && c.estado !== 328) {
      totalVenta += safeNumber(c.importe_total);
      if (c.a_cta_cte === 1) totalCuentaCorriente += safeNumber(c.importe_total);
      else totalContado += safeNumber(c.importe_total);
    }
  });

  /* ══════════════════════════════════════
     ANCHOS DE COLUMNAS
  ══════════════════════════════════════ */
const col0W = usableWidth * 0.09;  // Cantidad
const col1W = usableWidth * 0.28;  // Artículo
const col2W = usableWidth * 0.11;  // Precio sin IVA
const col3W = usableWidth * 0.11;  // Precio con IVA (nueva)
const col4W = usableWidth * 0.11;  // Neto
const col5W = usableWidth * 0.11;  // IVA
const col6W = usableWidth * 0.19;  // Importe c/IVA

const xEndNeto    = margin.left + col0W + col1W + col2W + col3W + col4W;
const xEndIva     = xEndNeto + col5W;
const xEndImporte = xEndIva  + col6W;

  /* ══════════════════════════════════════
     RECORRER CADA COMPROBANTE
  ══════════════════════════════════════ */
  for (let idx = 0; idx < facturas.length; idx++) {
    const c = facturas[idx];

    if (currentY + 160 > pageHeight - margin.bottom) {
      doc.addPage();
      currentY = margin.top;
    }

    const tipoCobro = c.a_cta_cte === 1 ? "CUENTA CORRIENTE" : "COBRO CONTADO";

    // ── ANULADA ──
    if (c.estado_factura === 260) {
      doc.setTextColor(200, 0, 0);
      doc.setFont(undefined, "bold");
      doc.setFontSize(8);
      doc.text(
        `ANULADA [comprobante ${c.nc_cod_compr || ""}-${c.nc_pto_venta || ""}-${c.nc_nro_comprobante || ""}]`,
        margin.left,
        currentY
      );
      currentY += 11;
      doc.setTextColor(0, 0, 0);
    }

    // ── CABECERA DEL COMPROBANTE — fondo gris muy suave ──
    doc.setFillColor(245, 245, 245);
    doc.rect(margin.left, currentY - 9, usableWidth, 20, "F");

    const fechaHora = c.fecha_hora_facturacion
      ? moment(c.fecha_hora_facturacion).format("DD-MM-YYYY HH:mm")
      : "";
    const headerLeft  = `${c.texto_comprobante} ${c.letra}-${c.pto_venta}-${c.nro_comprobante} [${fechaHora}]  —  PEDIDO #: ${c.id_pedido}`;
    const headerRight = `CAE: ${c.cae || ""}  [${tipoCobro}]`;

    doc.setFont(undefined, "bold");
    doc.setFontSize(8.5);
    doc.setTextColor(0, 0, 0);
    doc.text(headerLeft, margin.left + 5, currentY);
    doc.text(headerRight, pageWidth - margin.right - 5, currentY, { align: "right" });
    currentY += 16;

    // ── CLIENTE ──
    doc.setFont(undefined, "bold");
    doc.setFontSize(8);
    doc.setTextColor(60, 60, 60);
    doc.text(
      `Cliente: ${c.razon_social || ""} ${c.sisven_id != null ? `(${c.sisven_id})` : ""} — CUIT: ${c.cuit || "-"} — ${c.direccion_entrega || ""}`,
      margin.left,
      currentY
    );
    currentY += 11;

    const leyendas = [];
    if (c.texto_comprobante === "FACTURA" && c.a_consfinal === 1) leyendas.push("A Consumidor Final");
    if (c.texto_comprobante === "FACTURA" && c.a_cta_cte === 1) leyendas.push("A Cuenta Corriente");
    if (leyendas.length > 0) {
      doc.setFont(undefined, "normal");
      doc.setTextColor(100, 100, 100);
      doc.text(leyendas.join(" — "), margin.left, currentY);
      currentY += 11;
    }
    doc.setTextColor(0, 0, 0);

    // ── TABLA DE PRODUCTOS ──
    const productosDetalle = parseProductos(c.producto_fact_item);
    const totalNetoFactura = productosDetalle.reduce((sum, p) => sum + p.neto, 0);
    const totalIvaFactura  = productosDetalle.reduce((sum, p) => sum + p.iva,  0);

    const tableHeaders = ["Cantidad", "Artículo", "Precio Unit. sin IVA", "Precio Unit. con IVA", "Neto", "IVA", "Importe c/IVA"];
const tableBody = productosDetalle.map((prod) => [
  prod.cantidad.toFixed(2),
  prod.articulo,
  formatCurrency(prod.precioUnitario),
  formatCurrency(prod.precioUnitarioConIva),  // ← NUEVA COLUMNA
  prod.neto > 0 ? formatCurrency(prod.neto) : "",
  prod.iva  > 0 ? formatCurrency(prod.iva)  : "",
  formatCurrency(prod.importeConIva),
]);

    autoTable(doc, {
      startY: currentY,
      head: [tableHeaders],
      body: tableBody,
      theme: "plain",
      styles: {
        fontSize: 8,
        cellPadding: { top: 3, bottom: 3, left: 4, right: 4 },
        overflow: "linebreak",
        valign: "middle",
        textColor: [0, 0, 0],
      },
      headStyles: {
        fontStyle: "bold",
        halign: "center",
        fontSize: 8,
        fillColor: [235, 235, 235],
        textColor: [0, 0, 0],
        // lineColor: [180, 180, 180],
        lineWidth: { bottom: 0.5 },
      },
      bodyStyles: {
        fillColor: false,
        lineColor: [220, 220, 220],
        lineWidth: { bottom: 0.2 },
      },
      alternateRowStyles: {
        fillColor: [250, 250, 250],
      },
      columnStyles: {
  0: { cellWidth: col0W, halign: "center" },
  1: { cellWidth: col1W },
  2: { cellWidth: col2W, halign: "right" },
  3: { cellWidth: col3W, halign: "right" },  // ← nueva columna
  4: { cellWidth: col4W, halign: "right" },
  5: { cellWidth: col5W, halign: "right" },
  6: { cellWidth: col6W, halign: "right", fontStyle: "bold" },
},
      margin: { left: margin.left, right: margin.right },
    });

    currentY = doc.lastAutoTable.finalY + 2;

    // ── TOTALES DE LA FACTURA ──
    doc.setDrawColor(180, 180, 180);
    // doc.setLineWidth(0.3);
    // doc.line(margin.left + col0W + col1W + col2W, currentY, xEndImporte, currentY);
    currentY += 7;

    if (totalNetoFactura > 0 || totalIvaFactura > 0) {
      doc.setFont(undefined, "normal");
      doc.setFontSize(8);
      doc.setTextColor(80, 80, 80);
      doc.text(formatCurrency(totalNetoFactura),                   xEndNeto,    currentY, { align: "right" });
      doc.text(formatCurrency(totalIvaFactura),                    xEndIva,     currentY, { align: "right" });
      doc.text(formatCurrency(totalNetoFactura + totalIvaFactura), xEndImporte, currentY, { align: "right" });
      currentY += 10;
    }

    if (safeNumber(c.importe_perc_iva) > 0) {
      doc.setFont(undefined, "normal");
      doc.setFontSize(8);
      doc.setTextColor(80, 80, 80);
      doc.text("Perc. IVA:", xEndIva - 55, currentY);
      doc.text(formatCurrency(c.importe_perc_iva), xEndImporte, currentY, { align: "right" });
      currentY += 10;
    }
    if (safeNumber(c.importe_percepciones) > 0) {
      doc.setFont(undefined, "normal");
      doc.setFontSize(8);
      doc.setTextColor(80, 80, 80);
      doc.text("Otros Tributos:", xEndIva - 75, currentY);
      doc.text(formatCurrency(c.importe_percepciones), xEndImporte, currentY, { align: "right" });
      currentY += 10;
    }

    // Total final — bold y negro
    doc.setDrawColor(160, 160, 160);
    doc.setLineWidth(0.3);
    doc.line(xEndIva - 80, currentY - 2, xEndImporte, currentY - 2.5);
    doc.setFont(undefined, "bold");
    doc.setFontSize(8.5);
    doc.setTextColor(0, 0, 0);
    doc.text(formatCurrency(c.importe_total), xEndImporte, currentY + 5, { align: "right" });
    currentY += 16;
    doc.setFont(undefined, "normal");

    // ── ENVASES NO FACTURADOS ──
    const envasesNoFacturados = parseEnvases(c.envases_no_facturados);
    if (envasesNoFacturados.length > 0) {
      const totalEnvasesPedido = envasesNoFacturados.reduce((sum, e) => sum + e.total, 0);
      ensureSpace(40 + envasesNoFacturados.length * 14);
      doc.setFont(undefined, "bold");
      doc.setFontSize(7.5);
      doc.setTextColor(150, 100, 0);
      doc.text("Envases (no incluidos en la factura)", margin.left + 5, currentY);
      doc.setTextColor(0, 0, 0);
      currentY += 4;
      simpleTable(
        ["Cantidad", "Artículo", "Valor Unit.", "Total"],
        [
          ...envasesNoFacturados.map((e) => [
            e.cantidad,
            e.articulo || "",
            formatCurrency(e.valorEnvase),
            formatCurrency(e.total),
          ]),
          ["", "", "Total Envases:", formatCurrency(totalEnvasesPedido)],
        ],
        {
          columnStyles: { 0: { halign: "center" }, 2: { halign: "right" }, 3: { halign: "right" } },
          boldLastRow: true,
          left: margin.left + 5,
          gap: 10,
        }
      );
    }

    // ── ACLARACIÓN PROMO/SEÑA ──
// ── ACLARACIÓN PROMO/SEÑA ──
const aclaracion = getAclaracionPromoSena(c.aclaracion_promo_sena);
if (aclaracion) {
  doc.setDrawColor(200, 160, 80);
  doc.setLineWidth(0.5);
  const aclaracionLines = doc.splitTextToSize(aclaracion, usableWidth - 20);
  const boxHeight = aclaracionLines.length * 8 + 10;
  doc.rect(margin.left + 5, currentY - 2, usableWidth - 10, boxHeight, "D"); // Solo borde
  doc.setTextColor(80, 80, 80);
  doc.setFontSize(7.5);
  doc.text(aclaracionLines, margin.left + 10, currentY + 8);
  currentY += boxHeight + 6;
  doc.setTextColor(0, 0, 0);
}

    // ── MEDIOS DE PAGO ──
    const pagosComprobante = parseMedioPago(c.medios_pago_combinados);
    const pagosCargas  = pagosComprobante.filter((p) => !p.esEnvase);
    const pagosEnvCmp  = pagosComprobante.filter((p) =>  p.esEnvase);

    if (pagosCargas.length > 0) {
      doc.setFont(undefined, "bold");
      doc.setFontSize(8);
      doc.setTextColor(60, 60, 60);
      doc.text("Medios de Pago — Cargas:", margin.left, currentY);
      currentY += 9;
      doc.setFont(undefined, "normal");
      doc.setTextColor(0, 0, 0);
      pagosCargas.forEach((p) => {
        let label = `${p.nombre}  ${formatCurrency(p.monto)}`;
        if (p.detalle) label += `  (${p.detalle})`;
        doc.text(`• ${label}`, margin.left + 8, currentY);
        currentY += 10;
      });
      currentY += 3;
    }

    if (pagosEnvCmp.length > 0) {
      doc.setFont(undefined, "bold");
      doc.setFontSize(8);
      doc.setTextColor(60, 60, 60);
      doc.text("Envases:", margin.left, currentY);
      currentY += 9;
      doc.setFont(undefined, "normal");
      doc.setTextColor(0, 0, 0);
      pagosEnvCmp.forEach((p) => {
        let label = `${p.nombre}  ${formatCurrency(p.monto)}`;
        if (p.detalle) label += `  (${p.detalle})`;
        doc.text(`• ${label}`, margin.left + 8, currentY);
        currentY += 10;
      });
      if (c.remito_envase) { doc.text(`• Remito Envase: ${c.remito_envase}`, margin.left + 8, currentY); currentY += 10; }
      if (c.recibo_envase) { doc.text(`• Recibo Envase: ${c.recibo_envase}`, margin.left + 8, currentY); currentY += 10; }
      currentY += 3;
    }

    currentY += 6;

    // ── SEPARADOR ── punteado suave en vez de línea sólida gruesa
    if (idx < facturas.length - 1) {
      doc.setDrawColor(180, 180, 180);
      doc.setLineWidth(0.5);
      doc.setLineDashPattern([3, 3], 0);
      doc.line(margin.left, currentY, pageWidth - margin.right, currentY);
      doc.setLineDashPattern([], 0);
      currentY += 14;
    }
  }

  /* ══════════════════════════════════════
     RESUMEN DE MEDIOS DE PAGO (en pantalla sólo se muestra si hay pagos)
  ══════════════════════════════════════ */
  if (Array.isArray(pagos) && pagos.length > 0) {
    ensureSpace(120);

    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(0.8);
    doc.line(margin.left, currentY, pageWidth - margin.right, currentY);
    currentY += 14;

    doc.setFontSize(10);
    doc.setFont(undefined, "bold");
    doc.setTextColor(0, 0, 0);
    doc.text("RESUMEN DE MEDIOS DE PAGO", margin.left, currentY);
    currentY += 14;

    doc.setFontSize(9);

    const pagosGas    = pagos.filter((p) => p?.tipo_pago === "Gas");
    const pagosEnvase = pagos.filter((p) => p?.tipo_pago === "Envase");
    const totalEnvases = pagosEnvase.reduce((s, p) => s + safeNumber(p.total), 0);

    if (pagosGas.length > 0) {
      pagosGas.forEach((p) => {
        doc.setFont(undefined, "normal");
        doc.text(p.nombre_medio || "Sin nombre", margin.left + 8, currentY);
        doc.setFont(undefined, "bold");
        doc.text(formatCurrency(safeNumber(p.total)), pageWidth - margin.right, currentY, { align: "right" });
        currentY += 12;
      });
      currentY += 4;
    }

    if (totalCuentaCorriente > 0 && !pagos.some((p) => p.nombre_medio === "Cuenta Corriente")) {
      doc.setFont(undefined, "normal");
      doc.text("Cuenta Corriente", margin.left + 8, currentY);
      doc.setFont(undefined, "bold");
      doc.text(formatCurrency(totalCuentaCorriente), pageWidth - margin.right, currentY, { align: "right" });
      currentY += 12;
    }

    // TOTAL FACTURAS
    currentY += 4;
    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(0.5);
    doc.line(margin.left, currentY, pageWidth - margin.right, currentY);
    currentY += 10;
    doc.setFont(undefined, "bold");
    doc.setFontSize(10);
    doc.text("TOTAL FACTURAS", margin.left, currentY);
    doc.text(formatCurrency(totalVenta), pageWidth - margin.right, currentY, { align: "right" });
    currentY += 18;

    if (pagosEnvase.length > 0) {
      ensureSpace(40 + pagosEnvase.length * 12);
      doc.setFont(undefined, "bold");
      doc.setFontSize(9);
      doc.text("ENVASES", margin.left, currentY);
      currentY += 12;
      doc.setFont(undefined, "normal");
      pagosEnvase.forEach((p) => {
        doc.text(p.nombre_medio || "Sin nombre", margin.left + 8, currentY);
        doc.setFont(undefined, "bold");
        doc.text(formatCurrency(safeNumber(p.total)), pageWidth - margin.right, currentY, { align: "right" });
        doc.setFont(undefined, "normal");
        currentY += 12;
      });
      currentY += 4;
      doc.setFont(undefined, "bold");
      doc.text("TOTAL ENVASES", margin.left + 8, currentY);
      doc.text(formatCurrency(totalEnvases), pageWidth - margin.right, currentY, { align: "right" });
      currentY += 18;
    }
  }

  /* ══════════════════════════════════════
     ENTREGAS CON REMITO
  ══════════════════════════════════════ */
  if (Array.isArray(entregasConRemito) && entregasConRemito.length > 0) {
    sectionTitle("Entregas con Remito");
    simpleTable(
      ["ID Pedido", "Razón Social", "CUIT", "Dirección", "Producto", "Fecha", "N° Remito"],
      entregasConRemito.map((p) => [
        `#${p.id}`,
        p.razon_social || "-",
        p.cuit || "-",
        p.direccion_entrega || "-",
        p.producto_renglon || "-",
        formatFecha(p.fecha_para),
        p.remito_entrega || "-",
      ])
    );
  }

  /* ══════════════════════════════════════
     PEDIDOS SOLO ENVASES
  ══════════════════════════════════════ */
  if (Array.isArray(soloEnvases) && soloEnvases.length > 0) {
    const totalSoloEnvases = soloEnvases.reduce((sum, p) => sum + safeNumber(p.total_envases), 0);
    sectionTitle("Pedidos Solo Envases");
    simpleTable(
      ["ID Pedido", "Razón Social", "CUIT", "Dirección", "Envases", "Fecha", "Remito / Recibo", "Medios de Pago", "Importe"],
      [
        ...soloEnvases.map((p) => {
          const envases = parseEnvases(p.envases);
          const pagosPedido = parseMedioPago(p.medios_pago_combinados);
          return [
            `#${p.id}`,
            p.razon_social || "-",
            p.cuit || "-",
            p.direccion_entrega || "-",
            envases.length === 0
              ? "-"
              : envases.map((e) => `${e.cantidad} x ${e.articulo} (${formatCurrency(e.valorEnvase)} c/u)`).join("\n"),
            formatFecha(p.fecha_para),
            `Remito: ${p.remito_envase || "-"}\nRecibo: ${p.recibo_envase || "-"}`,
            pagosPedido.length === 0
              ? "-"
              : pagosPedido.map((pago) => `${pago.nombre} ${formatCurrency(pago.monto)}`).join("\n"),
            formatCurrency(p.total_envases),
          ];
        }),
        ["", "", "", "", "", "", "", "Total Solo Envases:", formatCurrency(totalSoloEnvases)],
      ],
      {
        columnStyles: {
          7: { minCellWidth: 70 },
          8: { halign: "right", minCellWidth: 60 },
        },
        boldLastRow: true,
      }
    );
  }

  /* ══════════════════════════════════════
     RESUMEN DE GARRAFAS (separado en carga / envases, como en pantalla)
  ══════════════════════════════════════ */
  if (Array.isArray(resumenGarrafas) && resumenGarrafas.length > 0) {
    // Productos envase (id_uso 367)
    const ID_USO_ENVASE = 367;
    const grupos = [
      { titulo: "Garrafas con carga", items: resumenGarrafas.filter((item) => Number(item?.id_uso) !== ID_USO_ENVASE) },
      { titulo: "Envases", items: resumenGarrafas.filter((item) => Number(item?.id_uso) === ID_USO_ENVASE) },
    ];

    ensureSpace(80);
    doc.setFontSize(10);
    doc.setFont(undefined, "bold");
    doc.setTextColor(0, 0, 0);
    doc.text("RESUMEN DE GARRAFAS", margin.left, currentY);
    currentY += 14;

    let totalGarrafas = 0;

    grupos.forEach(({ titulo, items }) => {
      if (!items.length) return;
      ensureSpace(40 + items.length * 12);

      doc.setFontSize(8.5);
      doc.setFont(undefined, "bold");
      doc.text(titulo, margin.left, currentY);
      doc.text("Cantidad", pageWidth - margin.right, currentY, { align: "right" });
      currentY += 8;
      doc.setDrawColor(160, 160, 160);
      doc.setLineWidth(0.4);
      doc.line(margin.left, currentY, pageWidth - margin.right, currentY);
      currentY += 10;

      doc.setFont(undefined, "normal");
      let subtotal = 0;
      items.forEach((item) => {
        const nombre = item?.nombre_producto || "Producto";
        const cantidad = safeNumber(item?.total_cantidad);
        subtotal += cantidad;
        doc.text(nombre, margin.left + 5, currentY);
        doc.setFont(undefined, "bold");
        doc.text(`${cantidad} unidades`, pageWidth - margin.right, currentY, { align: "right" });
        doc.setFont(undefined, "normal");
        currentY += 12;
      });
      totalGarrafas += subtotal;

      doc.setTextColor(100, 100, 100);
      doc.text(`Subtotal ${titulo.toLowerCase()}`, margin.left + 5, currentY);
      doc.setFont(undefined, "bold");
      doc.text(`${subtotal} unidades`, pageWidth - margin.right, currentY, { align: "right" });
      doc.setTextColor(0, 0, 0);
      currentY += 16;
    });

    doc.setDrawColor(160, 160, 160);
    doc.setLineWidth(0.4);
    doc.line(margin.left, currentY, pageWidth - margin.right, currentY);
    currentY += 10;
    doc.setFontSize(8.5);
    doc.setFont(undefined, "bold");
    doc.text("TOTAL GENERAL", margin.left + 5, currentY);
    doc.text(`${totalGarrafas} unidades`, pageWidth - margin.right, currentY, { align: "right" });
    currentY += 18;
  }

  /* ══════════════════════════════════════
     CORRELATIVIDAD (comprobantes faltantes)
  ══════════════════════════════════════ */
  if (Array.isArray(faltantes) && faltantes.length > 0) {
    ensureSpace(60);
    doc.setFontSize(9);
    doc.setFont(undefined, "bold");
    doc.setTextColor(200, 110, 0);
    doc.text(
      `Faltan ${faltantes.length} comprobante${faltantes.length > 1 ? "s" : ""}`,
      margin.left,
      currentY
    );
    currentY += 11;
    doc.setFontSize(8);
    doc.setFont(undefined, "normal");
    doc.setTextColor(0, 0, 0);
    const lineasFaltantes = doc.splitTextToSize(`Números faltantes: ${faltantes.join(", ")}`, usableWidth);
    doc.text(lineasFaltantes, margin.left, currentY);
    currentY += lineasFaltantes.length * 10 + 4;

    if (Array.isArray(datosFaltantes) && datosFaltantes.length > 0) {
      simpleTable(
        ["N° Comprobante", "Fecha", "Rendición", "Chofer"],
        datosFaltantes.map((d) => [
          `${d.pto_venta}-${d.nro_comprobante}`,
          moment(d.fecha_rendicion).format("DD-MM-YYYY"),
          d.nro_rendicion ?? "",
          d.nombre_apellido || "",
        ])
      );
    } else {
      doc.setTextColor(100, 100, 100);
      doc.text("No se encontraron datos en la base de datos para estos números.", margin.left, currentY);
      doc.setTextColor(0, 0, 0);
      currentY += 18;
    }
  }

  _finalizePDF();
};

return (
    <>
      <AppBar
        sx={{ position: "relative" }}
        style={{ backgroundColor: "#0979b0" }}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onBack}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Resumen de la rendición - #{row.nro_rendicion}
          </Typography>
          <Button
            variant="contained"
            color="secondary"
            startIcon={<DownloadIcon />}
            onClick={downloadPDF}
            sx={{
              backgroundColor: "#28a745",
              "&:hover": {
                backgroundColor: "#218838",
              },
            }}
          >
            Descargar PDF
          </Button>
        </Toolbar>
      </AppBar>
      <Backdrop
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 1,
          flexDirection: 'column',
          gap: 2
        }}
        open={loading}
      >
        <CircularProgress color="inherit" />
        <Typography variant="h6" sx={{ color: 'white' }}>
          Cargando datos...
        </Typography>
      </Backdrop>
      
      {/* Contenido principal - se muestra solo cuando no está cargando */}
      {!loading && (
        <Box p={2}>
          <Paper elevation={3} sx={{ p: 2 }}>
            <HeaderRendicion data={row} />
            <Box mt={3}>
              <TablaCambios cambios={cambios} />
            </Box>
            <Box mt={3}>
              <TablaPendientes pendientes={pendientes} />
            </Box>
            <Box mt={3}>
              <TablaDescartados descartados={descartados} />
            </Box>
            <Box mt={3}>
              <TablaComprobantes comprobantes={facturas} pagos={pagos} />
            </Box>

            <Box mt={3}>
              <TablaEntregasRemitos pendientes={entregasConRemito} />
            </Box>
            <Box mt={3}>
              <TablaSoloEnvases pedidos={soloEnvases} />
            </Box>
            <Box mt={3}>
              <ResumenGarrafas resumen={resumenGarrafas} />
            </Box>
            <Box>
              <VerificaCorrelatividad 
                faltantes={faltantes} 
                datosFaltantes={datosFaltantes} 
              />
            </Box>
          </Paper>
        </Box>
      )}
    </>
  );
}

export default ResumenRendicion;
